import React from 'react';
import { Section } from '../../types/Section';

interface SectionContainerProps {
    section: Section;
    children: React.ReactNode;
    className?: string;
}

export const SectionContainer: React.FC<SectionContainerProps> = ({
    section,
    children,
    className = ''
}) => {
    // Set default styles that can be overridden by section options
    const getBorderStyle = () => {
        switch (section.options?.border_style) {
            case 'none': return 'border-0';
            case 'square': return 'rounded-none';
            default: return 'rounded-lg';
        }
    };

    const getPadding = () => {
        switch (section.options?.padding) {
            case 'small': return 'p-3';
            case 'large': return 'p-8';
            case 'none': return 'p-0';
            default: return 'p-6';
        }
    };

    // Only apply card styling for non-text sections
    if (section.type === 'text') {
        return <div className={className}>{children}</div>;
    }

    return (
        <div
            className={`bg-white shadow-sm border border-gray-100 ${getBorderStyle()} ${getPadding()} h-full ${className}`}
            style={{
                backgroundColor: section.options?.background_color || '',
                color: section.options?.text_color || ''
            }}
        >
            {children}
        </div>
    );
};
